import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { SafelyRenderHtml } from '@src/services';

const getImageUrl = (image) => {
    if (!image) return null;

    return image.generated_url || image.url || image.source || null;
};

const OverviewSection = ({ data, id = 'new-overview' }) => {
    const {
        heading,
        image,
        list_html: listHtml,
        cta_label: ctaLabel,
        cta_url: ctaUrl,
    } = data || {};

    const imageUrl = getImageUrl(image);

    return (
        <section id={id} className="col-12 p-0">
            <div className="container-fluid p-0">
                <Row className="overview-module overview-simple main-container-row">
                    <Col lg={5} className="overview-module-left">
                        {
                            imageUrl
                                ? (
                                    <img
                                        alt=""
                                        className="overview-module-img"
                                        src={imageUrl}
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    />
                                )
                                : <div className="overview-module-img" />
                        }
                    </Col>
                    <Col lg={7} className="overview-module-right">
                        <div className="overview-right-column">
                            {heading && <h2>{SafelyRenderHtml(heading)}</h2>}
                            {listHtml && SafelyRenderHtml(listHtml)}
                            {
                                ctaLabel && ctaUrl
                                && (
                                    <a
                                        className="ml-button-secondary"
                                        href={ctaUrl}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                    >
                                        {SafelyRenderHtml(ctaLabel)}
                                    </a>
                                )
                            }
                        </div>
                    </Col>
                </Row>
            </div>
        </section>
    );
};

OverviewSection.propTypes = {
    data: PropTypes.shape({
        heading: PropTypes.string,
        image: PropTypes.shape({
            source: PropTypes.string,
            url: PropTypes.string,
            generated_url: PropTypes.string,
        }),
        list_html: PropTypes.string,
        cta_label: PropTypes.string,
        cta_url: PropTypes.string,
    }),
    id: PropTypes.string,
};

export default OverviewSection;
